import {createAction} from 'web-app/util/redux/famly-app-helpers';

import {type EmployeeBasicInfoFormData} from './types';

const domain = 'EMPLOYEE_PROFILE_BASIC_INFO';

export const {action: toggleEditBasicInfo} = createAction(`${domain}/TOGGLE_EDIT`, (edit: boolean) => ({edit}));

export const {
    action: saveBasicInfo,
    success: saveBasicInfoSuccess,
    failed: saveBasicInfoFailed,
} = createAction(`${domain}/SAVE`, (employeeId: string, formData: EmployeeBasicInfoFormData) => ({
    employeeId,
    formData,
}));
